import * as React from 'react';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';

export const NoStream = compose<TranslateProps, {}>(
    translate(),
)(props =>
    <div className="no-camera">
        { props.t('6.1241.0.92') }
    </div>
);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/NoStream.tsx